import React from 'react';
import { Box } from '@mui/material';

interface Props {
  height?: number;
  sx?: object;
  width?: number;
}

const GreenGradientCircleGraphic = ({
  height = 45,
  sx,
  width = 45,
}: Props) => (
  <Box sx={sx}>
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 68.25 68.01"
      width={width}
      height={height}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-482.87"
          y1="299.21"
          x2="-482.87"
          y2="298.12"
          gradientTransform="translate(27559 17058) scale(57 -57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#005596" />
          <stop offset="1" stopColor="#5bc2a7" />
        </linearGradient>
      </defs>
      <circle
        id="Ellipse_43"
        cx="35.13"
        cy="34"
        r="30.92"
        fill="url(#linear-gradient)"
        opacity=".47"
      />
    </svg>
  </Box>
);

export default GreenGradientCircleGraphic;
